import { useState, useEffect, useRef } from 'react';
import ReactSlider from 'react-slider';

const isEmpty = (v) => v === null || v === undefined || v === "";

const toPositions = (warningValue, dangerValue, min) => {
    if (isEmpty(warningValue) && isEmpty(dangerValue)) return [30, 90];
    const left = isEmpty(warningValue) ? 30 : Number(warningValue);
    const right = isEmpty(dangerValue) ? 90 : Number(dangerValue);
    return [Math.max(min, left), right];
};

export const StatusThresholdRangeSlider = ({ warningValue, dangerValue, onChange, min = 0, max = 240, disabled = false }) => {

    const [positions, setPositions] = useState(() => toPositions(warningValue, dangerValue, min));
    const dragging = useRef(false);

    useEffect(() => {
        if (!dragging.current) {
            setPositions(toPositions(warningValue, dangerValue, min));
        }
    }, [warningValue, dangerValue]);

    const handleChange = (value) => {
        dragging.current = true;
        setPositions(value);
        if (onChange) {
            onChange({ warning: value[0], danger: value[1] });
        }
    };

    const handleAfterChange = () => {
        dragging.current = false;
    };

    const nudge = (index, delta) => {
        setPositions(prev => {
            const next = [...prev];
            if (index === 0) {
                next[0] = Math.max(min, Math.min(next[0] + delta, next[1] - 1));
            } else {
                next[1] = Math.min(max, Math.max(next[1] + delta, next[0] + 1));
            }
            if (onChange) onChange({ warning: next[0], danger: next[1] });
            return next;
        });
    };

    const trackColours = ['bg-success', 'bg-warning', 'bg-danger'];

    return (
        <div className={`w-100 mt-1 mb-2${disabled ? ' threshold-slider--disabled' : ''}`}>
            <ReactSlider
                className="threshold-slider"
                min={min}
                max={max}
                value={positions}
                minDistance={1}
                pearling
                disabled={disabled}
                onChange={handleChange}
                onAfterChange={handleAfterChange}
                renderTrack={(props, state) => (
                    <div
                        {...props}
                        className={`threshold-slider-track ${trackColours[state.index]}`}
                    />
                )}
                renderThumb={(props, state) => (
                    <div {...props} className={`threshold-slider-thumb${disabled ? ' threshold-slider-thumb--disabled' : ''}`}>
                        {!disabled && (
                            <button
                                className="position-absolute btn p-0"
                                style={{ left: '-12px', top: '4px' }}
                                onClick={(e) => { e.stopPropagation(); nudge(state.index, -1); }}
                            >
                                <i className="fas fa-chevron-left text-dark fs--1"></i>
                            </button>
                        )}
                        {state.valueNow}
                        {!disabled && (
                            <button
                                className="position-absolute btn p-0"
                                style={{ right: '-12px', top: '4px' }}
                                onClick={(e) => { e.stopPropagation(); nudge(state.index, 1); }}
                            >
                                <i className="fas fa-chevron-right text-dark fs--1"></i>
                            </button>
                        )}
                    </div>
                )}
            />
        </div>
    );
};
